const getOrder = ordering => {
  if (ordering[0] === '-') {
    return 'DESC';
  }
  return 'ASC';
};

const getOrdering = ordering => {
  if (ordering) {
    const order = getOrder(ordering);

    return {
      key: ordering.replace('-', ''),
      sortBy: ordering.replace('-', ''),
      order,
    };
  }
  return null;
};

export default getOrdering;
